import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { dividendsApi } from '../services/api';

export function useDividends(year?: number) {
  return useQuery({
    queryKey: ['dividends', year],
    queryFn: () => dividendsApi.getAll({ year }),
  });
}

export function useDividendsCalendar(year?: number) {
  return useQuery({
    queryKey: ['dividends', 'calendar', year],
    queryFn: () => dividendsApi.getCalendar(year),
  });
}

export function useDividendsProjection(months = 12) {
  return useQuery({
    queryKey: ['dividends', 'projection', months],
    queryFn: () => dividendsApi.getProjection(months),
  });
}

export function useDividendsTotals() {
  return useQuery({
    queryKey: ['dividends', 'totals'],
    queryFn: dividendsApi.getTotals,
  });
}

export function useCreateDividend() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: dividendsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['dividends'] });
      toast.success('Provento registrado!');
    },
  });
}
